/*!
 * ADYJO BotGuard
 * Lightweight heuristic checks for obvious automation.
 * Best paired with Cloudflare WAF / rate limiting / challenge rules.
 */
(function (window, document) {
  'use strict';

  function suspicious() {
    var ua = navigator.userAgent || '';
    var webdriver = !!navigator.webdriver;
    var headless = /HeadlessChrome|PhantomJS|Puppeteer|Playwright|Selenium/i.test(ua);
    var noPlugins = navigator.plugins && navigator.plugins.length === 0;
    var noLanguages = !navigator.languages || navigator.languages.length === 0;
    var touchMismatch = navigator.maxTouchPoints === 0 && /Android|iPhone|iPad|iPod/i.test(ua);

    return webdriver || headless || (noPlugins && noLanguages) || touchMismatch;
  }

  function mark() {
    document.documentElement.setAttribute('data-adyjo-bot-suspected', suspicious() ? '1' : '0');
    document.documentElement.classList.toggle('adyjo-suspicious-client', suspicious());
  }

  function init() {
    mark();
    window.addEventListener('focus', mark, false);
    window.addEventListener('pageshow', mark, false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, false);
  } else {
    init();
  }
})(window, document);
